// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { SelectGroup } from './SelectGroup';
/**
 * 选项 实体类
 * 选项，当设置项为单选或多选的时候有效
 */
export class SelectOption extends BaseEntity {
  /** Name : 名称 */
  private _name: string;

  /** 设置：Name */
  public get name() {
    return this._name;
  }

  /** 获取：Name */
  public set name(value: string) {
    this._name = value;
  }

  /** 选项值 : 选项值，采用二进制值 */
  private _optionValue: number;

  /** 设置：选项值 */
  public get optionValue() {
    return this._optionValue;
  }

  /** 获取：选项值 */
  public set optionValue(value: number) {
    this._optionValue = value;
  }

  /** 编码 : 编码，程序使用的标志，不可更改 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 描述 : 描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 选项组 的ID */
  private _selectGroup_ID: string;

  /** 获取：选项组 的ID */
  public get selectGroup_ID() {
    return this._selectGroup_ID;
  }

  /** 设置：选项组 的ID */
  public set selectGroup_ID(value: string) {
    this._selectGroup_ID = value;
  }

  /** 选项组  */
  private _selectGroup: SelectGroup;

  /** 获取：选项组  */
  public get selectGroup() {
    return this._selectGroup;
  }

  /** 设置：选项组  */
  public set selectGroup(value: SelectGroup) {
    this._selectGroup = value;
    if (value !== null) {
      this.selectGroup_ID = value.id;
    } else {
      this.selectGroup_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._optionValue = 1;
    this._code = '';
    this._description = '';
    this._selectGroup_ID = '';
    this._selectGroup = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: SelectOption, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.optionValue = element.optionValue;
      this.code = element.code;
      this.description = element.description;
      this.selectGroup_ID = element.selectGroup_ID;
      if (hasReference && element.selectGroup !== null) {
        this.selectGroup = element.selectGroup;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.optionValue = json.OptionValue;
    this.code = json.Code;
    this.description = json.Description;
    this.selectGroup_ID = json.SelectGroup_ID;
    // if (json.SelectGroup !== null) {
    //   this.selectGroup = SelectGroup.Create(json.SelectGroup);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.OptionValue = this.optionValue;
    json.Code = this.code;
    json.Description = this.description;
    json.SelectGroup_ID = this.selectGroup_ID;
  }

  static Create(json: any): SelectOption {
    const selectOption = new SelectOption();
    selectOption.Deserialize(json);
    selectOption.json = json;
    return selectOption;
  }
}
